import React from 'react';
import authClient from './rest/authClient'
import { Admin, Resource, Delete } from 'admin-on-rest'
import { DealerList } from './Dealers'
import { DealershipList } from './Dealerships'
import { BankList } from './Banks'
import createHistory from 'history/createBrowserHistory'
import { DCAccountList, DCAccountEdit, DCAccountCreate } from './DCAccount'
import { CollectorAccountList, CollectorAccountEdit } from './CollectorAccount'
import { SalesSupportHeadAccountList } from './SalesSupportHead'
import { SalesSupportHeadAccountDocDefList } from './SalesSupportHead/DocDef'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import Menu from './Menu';
import WPRestClient from './rest/WPRestClient'
import UserIcon from 'material-ui/svg-icons/social/group'
import accountSagas from './accountSagas'
import { messages } from './accountSagas'
// import { userIs } from './util'
import { BranchList } from './Branches'
import { customRoutes } from './routes';
import { DealershipPerformance } from './reports/DealershipPerformance'
import { SalesSupportTeamIncentive, SalesSupportTeamIncentiveEdit } from './reports/SalesSupportTeamIncentive'
import { CCOfficerIncentive } from './reports/CCOfficerIncentive'
import { CollectionsDealership } from './reports/CollectionsDealership'
import { CollectionsBank } from './reports/CollectionsBank'
import { CollectionsAccountList } from './reports/CollectionsAccountList'
import { BankList as BankListReport } from './reports/BankList'
import { DocumentationPerformance } from './reports/DocumentationPerformance'
import { CollectionPerformance } from './reports/CollectionPerformance'
import { CollectionStatus } from './reports/CollectionStatus'
import { AccountsReceivable } from './reports/AccountsReceivable'
import { AccountsReceivableRelease } from './reports/AccountsReceivableRelease'
// import { TotalAccountsReceivableReleased } from './reports/TotalAccountsReceivableReleased'
// import { TotalAccountsReceivable } from './reports/TotalAccountsReceivable'
import Login from './Login'
import AccountShow from './Account/AccountShow'

// export const restURL = 'http://artracker:8888/wp-json/wp/v2'
// export const restTokenURL = 'http://artracker:8888/wp-json/jwt-auth/v1/token'
// export const restURL = 'https://lica.pyploo.com/wp/wp-json/wp/v2'
// export const restTokenURL = 'https://lica.pyploo.com/wp/wp-json/jwt-auth/v1/token'
export const restURL = 'https://collections.licagroup.biz/wp/wp-json/wp/v2'
export const restTokenURL = 'https://collections.licagroup.biz/wp/wp-json/jwt-auth/v1/token'

const restClient = WPRestClient(restURL)

const licaTheme = {
    fontFamily: 'Roboto, sans-serif',
	palette: {
		"primary1Color": "#0277bd",
        "accent1Color": "#d50000",
        "primary2Color": "#0d47a1"
	},
	"tabs": {
        "backgroundColor": "#ffffff",
        "textColor": "#757575",
        "selectedTextColor": "#d50000"
    },
	drawer: {
		width: 350, // Sidebar size.
	}
};

export const history = createHistory();

const getEditView = ( permissions ) => {
	if ( permissions.role.indexOf( 'dc' ) !== -1 ) {
		return DCAccountEdit
	} else if ( permissions.role.indexOf( 'collector' ) !== -1 ) {
		return CollectorAccountEdit
	}
	return AccountShow
}

const getListView = ( permissions ) => {
	if ( permissions.role.indexOf( 'dc' ) !== -1 ) {
		return DCAccountList
	} else if ( permissions.role.indexOf( 'collector' ) !== -1 ) {
		return CollectorAccountList
	}
	return null
}

const getCreateView = ( permissions ) => {
	if ( permissions.role.indexOf( 'dc' ) !== -1 ) {
		return DCAccountCreate
	}
	return null
}

const getDeleteView = ( permissions ) => {
	if ( permissions.role.indexOf( 'dc' ) !== -1 ) {
		return Delete
	}
	return null
}

// Redirect to the login page if not logged in.
if ( ! localStorage.getItem( 'user_id' ) ) {
	history.push( '/login' )
}

const App = () => {

	return (
	    <Admin
			title="Lica Auto Group AR Tracker"
			menu={Menu}
			history={history}
			theme={getMuiTheme(licaTheme)}
			authClient={authClient(restTokenURL)}
			restClient={restClient}
			customSagas={[accountSagas]}
			customRoutes={customRoutes}
			messages={messages}
			loginPage={Login}
			>
			{permissions => [

				/**
				 * Checker if not logged in. If this is removed, logged out
				 * people will show a "not found" page.
				 * This happens because Admin-on-Rest needs to perform a REST
				 * call with a 403 result in order to redirect to the login page.
				 */
				/*
				permissions.user_id !== null ? null :
				<Resource name="accounts" list={DCAccountList}/>,
				*/
				<Resource name="accounts"
					list={ getListView( permissions ) }
					edit={ getEditView( permissions ) }
					create={ getCreateView( permissions ) }
					delete={ getDeleteView( permissions ) } />,

				/**
				 * DC & Collector accounts.
				 */

/*
			 	permissions.role.indexOf( 'dc' ) === -1 && permissions.role.indexOf( 'collector' ) === -1 ? null :
				<Resource name="accounts"
					icon={ UserIcon }
					list={ permissions.role.indexOf( 'dc' ) !== -1 ? DCAccountList : CollectorAccountList }
					edit={ getEditView( permissions ) }
					create={ permissions.role.indexOf( 'dc' ) !== -1 ? DCAccountCreate : null }
					remove={ Delete } />,*/
				permissions.role.indexOf( 'dc' ) === -1 && permissions.role.indexOf( 'collector' ) === -1 ? null :
				<Resource name="branches" list={BranchList} options={{ label: 'Branch List' }} />,
				permissions.role.indexOf( 'dc' ) === -1 && permissions.role.indexOf( 'collector' ) === -1 ? null :
				<Resource name="dealers" list={DealerList} options={{ label: 'Dealer List' }} />,
				permissions.role.indexOf( 'dc' ) === -1 && permissions.role.indexOf( 'collector' ) === -1 ?
				 	<Resource name="dealerships" />:
					<Resource name="dealerships" list={DealershipList} options={{ label: 'Dealership List' }} />,
				permissions.role.indexOf( 'dc' ) === -1 && permissions.role.indexOf( 'collector' ) === -1 ? null :
				<Resource name="pending_docs" />,
				permissions.role.indexOf( 'dc' ) === -1 && permissions.role.indexOf( 'collector' ) === -1 ? null :
				<Resource name="doc_defs" />,
				permissions.role.indexOf( 'dc' ) === -1 && permissions.role.indexOf( 'collector' ) === -1 ?
					<Resource name="banks"/> :
					<Resource name="banks" list={BankList} options={{ label: 'Bank List' }}/>,

				<Resource name="bank_payment_modes" />,
				<Resource name="statuses" />,

				/**
				 * Sales support head.
				 */

				permissions.role.indexOf( 'sales_support_head' ) === -1 ? null :
				<Resource name="accounts_support_head_transmittal"
					icon={ UserIcon }
					create={ permissions.role.indexOf( 'dc' ) !== -1 ? DCAccountCreate : null }
					remove={ Delete }
					list={SalesSupportHeadAccountList} />,
				permissions.role.indexOf( 'sales_support_head' ) === -1 ? null :
				<Resource name="accounts_support_head_doc_def"
					icon={ UserIcon }
					create={ permissions.role.indexOf( 'dc' ) !== -1 ? DCAccountCreate : null }
					remove={ Delete }
					list={SalesSupportHeadAccountDocDefList} />,

				/**
				 * Reports.
				 */

				permissions.reports.indexOf( 'dealership_performance' ) === -1 ? null :
				<Resource name="report_dealership_performance" list={DealershipPerformance} options={{ label: 'Dealership Performance' }} />,

				permissions.reports.indexOf( 'sales_support_team_incentive' ) === -1 ? null :
				<Resource name="report_sales_support_team_incentive" list={SalesSupportTeamIncentive} edit={SalesSupportTeamIncentiveEdit} options={{ label: 'Sales Support Team Incentive' }} />,
				permissions.reports.indexOf( 'cc_officer_incentive' ) === -1 ? null :
				<Resource name="report_cc_officer_incentive" list={CCOfficerIncentive} options={{ label: 'C&C Officer Incentive' }} />,

				permissions.reports.indexOf( 'collections' ) === -1 ? null :
				<Resource name="report_collections_dealership" list={CollectionsDealership} options={{ label: 'Collections by Dealership' }} />,
				permissions.reports.indexOf( 'collections' ) === -1 ? null :
				<Resource name="report_collections_bank" list={CollectionsBank} options={{ label: 'Collections by Bank' }} />,
				permissions.reports.indexOf( 'collections' ) === -1 ? null :
				<Resource name="report_ar_report" list={AccountsReceivable} options={{ label: 'Monthly AR Report Baed on Date to Bank' }} />,
				permissions.reports.indexOf( 'collections' ) === -1 ? null :
				<Resource name="report_ar_report_release" list={AccountsReceivableRelease} options={{ label: 'Monthly AR Report Based on Release' }} />,
				permissions.reports.indexOf( 'collections' ) === -1 ? null :
				<Resource name="report_collections_accounts" list={CollectionsAccountList} options={{ label: 'Account Collections List' }} />,

				permissions.reports.indexOf( 'bank_collections' ) === -1 ? null :
				<Resource name="report_bank" list={BankListReport} options={{ label: 'Bank Report' }} />,

				permissions.reports.indexOf( 'documentation_performance' ) === -1 ? null :
				<Resource name="report_documentation_performance" list={DocumentationPerformance} options={{ label: 'Document Performance' }} />,
				permissions.reports.indexOf( 'documentation_performance' ) === -1 ? null :
				<Resource name="report_collection_performance" list={CollectionPerformance} options={{ label: 'Collection Performance' }} />,
				permissions.reports.indexOf( 'documentation_performance' ) === -1 ? null :
				<Resource name="report_collection_status" list={CollectionStatus} options={{ label: 'Collection Status' }} />,

			]}
	    </Admin>
	);
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js